import React from 'react'
import { MasterCard, PayMethodTitle, Paypal, Visa } from '../../../Utils/Constants'
import { H6 } from '../../../AbstractElements'
import { FormGroup, Input, Label } from 'reactstrap'
import { RadioPayMethodProps } from '../../../Types/FormType'

export default function RadioPayMethod({ colClass }:RadioPayMethodProps) {
    
    return (
        <div className={colClass}>
            <div className="card-wrapper border rounded-3 checkbox-checked">
                <H6 className="sub-title">{PayMethodTitle}</H6>
                <div className="radio-form">
                    <FormGroup check>
                        <Input type="radio" name="flexRadioDefault" required />
                        <Label check>{Visa}</Label>
                    </FormGroup>
                    <FormGroup check>
                        <Input type="radio" name="flexRadioDefault" required />
                        <Label check>{MasterCard}</Label>
                    </FormGroup>
                    <FormGroup check>
                        <Input type="radio" name="flexRadioDefault" defaultChecked required />
                        <Label check>{Paypal}</Label>
                    </FormGroup>
                </div>
            </div>
        </div>
    )
}